import { render, staticRenderFns } from "./Copyrights.vue?vue&type=template&id=7ec4f42c"
import script from "./Copyrights.vue?vue&type=script&lang=js"
export * from "./Copyrights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports